import { useI18n } from '../i18n';
import { formatPrice, savePercent, useWebPrices } from '../lib/webPrices';
import { MONTH_LABEL } from '../lib/pricing';

// "From 49 kr. / md  −15% yearly" for upsell cards, in the currency PayPal
// will actually charge. Shows nothing until the server has quoted a price, and
// nothing in the Android app, where Google Play sets its own prices.
export default function PremiumFromPrice() {
    const { t, locale } = useI18n();
    const native = !!(typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.());
    const prices = useWebPrices(locale, !native);
    if (native || !prices) return null;
    const save = savePercent(prices);
    const lang = (locale || 'en').split('-')[0];
    return (
        <span className="block text-xs text-white/80 mt-0.5" data-testid="premium-from-price">
            {t('premium.from')} {formatPrice(prices.monthly, prices.currency, locale)} {MONTH_LABEL[lang] || MONTH_LABEL.en}
            {save > 0 && <span className="ml-2 bg-white/20 px-1.5 py-0.5 rounded-full text-[9px] uppercase tracking-wider font-semibold">−{save}% {t('home.yearly')}</span>}
        </span>
    );
}
